import React from 'react';
import Header from "../components/layout/Header";
import Wrapper from "../components/layout/Wrapper";
import Footer from "../components/layout/Footer";
import {Helmet} from "react-helmet-async";


const Rules = () => {
    return (
        <>
            <Helmet>
                <title>قوانین و شرایط استفاده - کدپرو</title>
            </Helmet>

            <div className='flex flex-col min-h-screen'>
                <Header/>
                <Wrapper className='flex-1 my-10'>
                    <div className='w-1/2 mx-auto relative'>

                    </div>
                </Wrapper>
                <Footer/>
            </div>
        </>
    );
};

export default Rules;
